import { createContext } from 'react'

// RHF has no native warning channel; the withForm adapter computes redux-form-style warnings here and the dual-mode formField reads each field's by path (keyed like redux-form errors).
export const FormWarningsContext = createContext<Record<string, any>>({})
